// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type FreeDay, FreeDayUpdate } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateFreeDay(): (
  id: string,
  requestBody: FreeDayUpdate
) => Promise<FreeDay> {
  const getAPI = useGetApi();
  return useCallback(
    async (id, requestBody) =>
      (await getAPI()).freeDays.updateFreeDay({ id, requestBody }),
    [getAPI]
  );
}
